import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.index-of.js";
import _isFunction from "lodash/isFunction";
var _excluded = ["egn", "_municipalities", "_cities"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Paper, Form, Row, Col, Input, Button } from 'components/UI';
import { BorrowerData, BorrowerDataForm } from 'components/screens';
import IdCardScanModal from 'components/screens/Borrower/IdCardScanModal';
import { checkIdNumber } from 'services';
import { digitsOnlyPattern, showApiError } from 'utils';
import { jsx as ___EmotionJSX } from "@emotion/react";

var egnBadge = function egnBadge(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1.2em 1.6em',
    backgroundColor: theme.gray50,
    border: "1px solid ".concat(theme.gray150),
    marginBottom: '2em',
    '& .egn-label': {
      fontSize: '1.4rem',
      fontWeight: 500,
      color: theme.gray700,
      '& span': {
        fontWeight: 600
      }
    }
  };
};

var newBorrowerCard = function newBorrowerCard(theme) {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '4em 2em',
    border: "2px dashed ".concat(theme.gray200),
    backgroundColor: theme.gray50,
    '& .new-borrower-icon': {
      width: '5rem',
      height: '5rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '2.4rem',
      color: theme.primary,
      backgroundColor: theme.primaryLight,
      marginBottom: '1.6rem'
    },
    '& .new-borrower-title': {
      fontSize: '1.6rem',
      fontWeight: 600,
      color: theme.gray800,
      marginBottom: '0.6rem'
    },
    '& .new-borrower-subtitle': {
      fontSize: '1.3rem',
      color: theme.gray500,
      marginBottom: '2rem',
      maxWidth: 360
    }
  };
};

var IdNumberCheck = function IdNumberCheck(_ref) {
  var data = _ref.data,
      borrowerIdNumber = _ref.borrowerIdNumber,
      isGuarantor = _ref.isGuarantor,
      onNext = _ref.onNext,
      onClose = _ref.onClose,
      onBorrowerChange = _ref.onBorrowerChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isEdit = _useState2[0],
      setIsEdit = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showScanModal = _useState4[0],
      setShowScanModal = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      ocrData = _useState6[0],
      setOcrData = _useState6[1];

  var _useState7 = useState({
    municipalities: [],
    cities: []
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      ocrAddressLists = _useState8[0],
      setOcrAddressLists = _useState8[1];

  var hasBorrower = !!(data !== null && data !== void 0 && data.id_number);

  var runEgnCheck = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(egnValue) {
      var _yield$checkIdNumber, _yield$checkIdNumber2, res, err, borrowerResult;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return checkIdNumber(egnValue);

            case 2:
              _yield$checkIdNumber = _context.sent;
              _yield$checkIdNumber2 = _slicedToArray(_yield$checkIdNumber, 2);
              res = _yield$checkIdNumber2[0];
              err = _yield$checkIdNumber2[1];

              if (!err) {
                _context.next = 9;
                break;
              }

              showApiError(err);
              return _context.abrupt("return", true);

            case 9:
              borrowerResult = res ? _objectSpread(_objectSpread({}, res), {}, {
                newBorrower: false
              }) : {
                id_number: egnValue,
                newBorrower: true
              };
              _isFunction(onBorrowerChange) && onBorrowerChange(borrowerResult); // Auto-open the data form for new borrowers after scanning

              if (!res) setIsEdit(true);
              return _context.abrupt("return", false);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function runEgnCheck(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3) {
      var values;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              values = _ref3.values;
              return _context2.abrupt("return", runEgnCheck(values === null || values === void 0 ? void 0 : values.idNumber));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleOcrApply = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(ocrFormValues) {
      var egn, _municipalities, _cities, rest;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setShowScanModal(false);
              egn = ocrFormValues.egn, _municipalities = ocrFormValues._municipalities, _cities = ocrFormValues._cities, rest = _objectWithoutProperties(ocrFormValues, _excluded);
              setOcrData(rest);
              setOcrAddressLists({
                municipalities: _municipalities !== null && _municipalities !== void 0 ? _municipalities : [],
                cities: _cities !== null && _cities !== void 0 ? _cities : []
              });

              if (!egn) {
                _context3.next = 7;
                break;
              }

              _context3.next = 7;
              return runEgnCheck(egn);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleOcrApply(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleClose = function handleClose() {
    _isFunction(onClose) && onClose();
  };

  var handleReset = function handleReset() {
    _isFunction(onBorrowerChange) && onBorrowerChange({});
    setOcrData(null);
    setOcrAddressLists({
      municipalities: [],
      cities: []
    });
    setIsEdit(false);
  };

  var handleUpdateBorrower = function handleUpdateBorrower(updatedData) {
    setIsEdit(false);
    _isFunction(onBorrowerChange) && onBorrowerChange(updatedData);
  }; // Show EGN input form when no borrower is loaded yet


  if (!hasBorrower) {
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Paper, {
      header: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043D\u0430 \u0415\u0413\u041D ".concat(isGuarantor ? 'поръчител' : ''),
      margin: "2em 0"
    }, ___EmotionJSX(Form, {
      onSubmit: handleSubmit,
      values: {
        idNumber: borrowerIdNumber !== null && borrowerIdNumber !== void 0 ? borrowerIdNumber : ''
      }
    }, ___EmotionJSX(Row, {
      horizontalGap: 16,
      verticalGap: 8
    }, ___EmotionJSX(Col, null, ___EmotionJSX(Input, {
      pattern: digitsOnlyPattern,
      formId: "idNumber",
      label: "\u0415\u0413\u041D",
      required: true
    })), ___EmotionJSX(Col, {
      displayFlex: true,
      md: 12,
      justify: "flex-end"
    }, function (_ref6) {
      var onSubmit = _ref6.onSubmit;
      return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Button, {
        type: "secondary",
        onClick: handleClose,
        margin: "0 1em 0 0"
      }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"), ___EmotionJSX(Button, {
        type: "secondary",
        onClick: function onClick() {
          return setShowScanModal(true);
        },
        margin: "0 1em 0 0"
      }, ___EmotionJSX("i", {
        className: "las la-camera",
        style: {
          marginRight: 6
        }
      }), "\u0421\u043A\u0430\u043D\u0438\u0440\u0430\u0439 \u043B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430"), ___EmotionJSX(Button, {
        onClick: onSubmit
      }, "\u041F\u0440\u043E\u0432\u0435\u0440\u0438"));
    })))), showScanModal && ___EmotionJSX(IdCardScanModal, {
      open: showScanModal,
      onClose: function onClose() {
        return setShowScanModal(false);
      },
      onApply: handleOcrApply
    }));
  } // Once borrower is found/created — show badge + borrower details


  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    css: egnBadge
  }, ___EmotionJSX("span", {
    className: "egn-label"
  }, "\u0415\u0413\u041D: ", ___EmotionJSX("span", null, data === null || data === void 0 ? void 0 : data.id_number), isGuarantor && ' (поръчител)'), ___EmotionJSX(Button, {
    small: true,
    type: "secondary",
    onClick: handleReset
  }, "\u041F\u0440\u043E\u043C\u0435\u043D\u0438 \u0415\u0413\u041D")), isEdit ? ___EmotionJSX(Paper, {
    header: isGuarantor ? 'Данни на поръчител' : 'Данни на кредитополучател',
    margin: "0 0 2em 0"
  }, ___EmotionJSX(BorrowerDataForm, {
    data: data,
    ocrData: ocrData,
    ocrAddressLists: ocrAddressLists,
    onBorrowerChange: handleUpdateBorrower,
    onNext: function onNext() {
      return setIsEdit(false);
    }
  })) : data !== null && data !== void 0 && data.newBorrower ? ___EmotionJSX("div", {
    css: newBorrowerCard
  }, ___EmotionJSX("div", {
    className: "new-borrower-icon"
  }, ___EmotionJSX("i", {
    className: "las la-user-plus"
  })), ___EmotionJSX("p", {
    className: "new-borrower-title"
  }, "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D ".concat(isGuarantor ? 'поръчител' : 'кредитополучател')), ___EmotionJSX("p", {
    className: "new-borrower-subtitle"
  }, "\u041D\u0435 \u0435 \u043E\u0442\u043A\u0440\u0438\u0442 \u0437\u0430\u043F\u0438\u0441 \u0437\u0430 \u0415\u0413\u041D ".concat(data === null || data === void 0 ? void 0 : data.id_number, ". \u0414\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u043D\u043E\u0432 ").concat(isGuarantor ? 'поръчител' : 'кредитополучател', ", \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435.")), ___EmotionJSX(Button, {
    onClick: function onClick() {
      return setIsEdit(true);
    }
  }, ___EmotionJSX("i", {
    className: "las la-plus",
    style: {
      marginRight: 6
    }
  }), "\u0414\u043E\u0431\u0430\u0432\u0438 ", isGuarantor ? 'поръчител' : 'кредитополучател')) : ___EmotionJSX(Paper, {
    header: function header(_ref7) {
      var css = _ref7.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, isGuarantor ? 'Поръчител' : 'Кредитополучател'), ___EmotionJSX(Button, {
        small: true,
        type: "secondary",
        onClick: function onClick() {
          return setIsEdit(true);
        }
      }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0430\u0439"));
    },
    margin: "0 0 2em 0"
  }, ___EmotionJSX(BorrowerData, {
    data: data
  }), ___EmotionJSX(Row, {
    horizontalGap: 16,
    verticalGap: 8
  }, ___EmotionJSX(Col, {
    displayFlex: true,
    md: 12,
    justify: "flex-end"
  }, ___EmotionJSX(Button, {
    onClick: onNext
  }, "\u041D\u0430\u043F\u0440\u0435\u0434")))));
};

IdNumberCheck.propTypes = {
  data: PropTypes.object,
  borrowerIdNumber: PropTypes.string,
  isGuarantor: PropTypes.bool,
  onNext: PropTypes.func,
  onClose: PropTypes.func,
  onBorrowerChange: PropTypes.func
};
export default IdNumberCheck;